import React, { ChangeEvent, ReactNode } from "react";
import {
  BaseTextFieldProps,
  Stack,
  TextField,
  styled,
  Typography,
} from "@mui/material";
import { MuiStyledWrapper } from "./MuiTextFiled.style";
import ImageAssets from "../../../assets";
import strings from "../../../strings/Strings";

export interface IMuiTextFieldProps extends BaseTextFieldProps {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  InputProps?: { [key: string]: ReactNode };
  label: string;
  type?: string;
  maxLength?: number;
  name: string;
  isErrorThere?: boolean;
  servermessage: string;
  texFieldSize?: string;
  component?: React.ElementType;
}

const Item = styled("div") <any>`
  margin-top: 0px !important;
  padding: ${({ theme }) => theme.spacing(0.5)};
  text-align: center;
  color: var(--white-color);
`;
const Wrapper = styled("div") <any>`
  .error-message-container {
    margin-left: 1.6rem;
  }

  @media screen and (max-width: 376px) {
    .error-message-container {
      position: relative !important;
    }
  }
`;

const MuiTextField = (props: any) => {
  const {
    maxLength,
    errormessage,
    helpermessage,
    shouldDisplayError,
    texFieldSize,
    size,
    component
  } = props;

  return (
    <MuiStyledWrapper
      value={props.value}
      isErrorThere={errormessage !== ""}
      helpermessage={helpermessage !== ""}
      texFieldSize={texFieldSize}
    >
      <TextField
        autoComplete={"off"}
        size={size ? size : "medium"}
        inputProps={{ maxLength: maxLength ? maxLength : "" }}
        {...props}
      />
      <Wrapper>
        {errormessage === "" &&
          !shouldDisplayError &&
          helpermessage !== undefined &&
          helpermessage !== "" && (
            <Stack
              data-testid="error-message"
              className="error-message-container"
              flexDirection={"row"}
              alignItems={"center"}
              spacing={0}
              sx={{ background: "none" }}
            >
              <Item>
                <img
                  alt="error"
                  src={
                    helpermessage.toLowerCase() ===
                      strings.userNameExist?.toLowerCase()
                      ? ImageAssets.ic_error_info
                      : ImageAssets.ic_success_info
                  }
                />
              </Item>
              <Item>
                <Typography
                  className={
                    helpermessage.toLowerCase() ===
                      strings.userNameExist?.toLowerCase()
                      ? "input-error"
                      : "success-message"
                  }
                >
                  {helpermessage}
                </Typography>
              </Item>
            </Stack>
          )}
        {errormessage !== "" && !shouldDisplayError ? (
          <Stack
            data-testid="error-message"
            className="error-message-container"
            flexDirection={"row"}
            alignItems={"center"}
            spacing={0}
            sx={{ background: "none" }}
          >
            <img alt="error" src={ImageAssets.ic_error_info} />
            <Item>
              {errormessage && errormessage.split("\n").map((text) => (
                <Typography className="input-error" key={text}>
                  {text}
                </Typography>
              ))}
            </Item>
          </Stack>
        ) : (
          <div
            style={component && component === "registrationV1" ? {} : { visibility: "hidden", height: shouldDisplayError ? "0px" : "27px", }}
          ></div>
        )}
      </Wrapper>
    </MuiStyledWrapper>
  );
};

export { MuiTextField };
